import React from "react";
import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import AboutSection from "../components/UI/AboutSection";
import { Container, Row, Col } from "reactstrap";
import OurMembers from "../components/UI/OurMembers";
import { useTranslation } from "../hooks/useTranslation";
import "../styles/about.css";
import driveImg from "../assets/all-images/slider-img/slider-1.jpg";
import ServicesList from "../components/UI/ServicesList";

const Services = () => {
  const t = useTranslation();

  return (
    <Helmet title={t("about.title")}>
      <ServicesList />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <p className="section__description" style={{ textAlign: "center" }}>
          {t("about.aboutpagetitle")}
        </p>
      </div>
    </Helmet>
  );
};

export default Services;
